import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import { useEffect } from 'react';
import { Route, BrowserRouter as Router, Routes, useLocation, useNavigate } from "react-router-dom";
import './App.css';
import AdminPrivateRoute from "./Individual/Components/PrivateRoute/AdminPrivateRoute";
import AuditorPrivateRoute from "./Individual/Components/PrivateRoute/AuditorPrivateRoute";
import AuthWrapper from './Individual/Components/PrivateRoute/AuthWrapper';
import DuserPrivateRoute from "./Individual/Components/PrivateRoute/DuserPrivateRoute";
import AutoLogout from "./MainComponents/AutoLogout/AutoLogout";


import Contact from './MainComponents/Contact';
import Features from './MainComponents/Features';
import HomePage from './MainComponents/HomePage';
import Overview from './MainComponents/Overview';
import Pricing from './MainComponents/Pricing';


import AuditorForgotPassword from './Individual/Components/ForgotPassword/AuditorForgotPassword';
import DuserForgotPassword from './Individual/Components/ForgotPassword/DuserForgotPassword';
import ForgotPassword from './Individual/Components/ForgotPassword/ForgotPassword';


import LoginTabs from './Individual/Components/Login/LoginTabs';
import BusinessRegister from './Individual/Components/Register/BusinessRegister';
import IndividualRegister from './Individual/Components/Register/IndividualRegister';

import RegisterTabs from './Individual/Components/Register/RegisterTabs';
import Navbar from './Individual/Components/navbar/Navbar';
import ChecklistOverview from './Individual/Pages/Checklist/ChecklistOverview';
import CreateChecklist from './Individual/Pages/Checklist/CreateChecklist';
import QuestionsPage from './Individual/Pages/Checklist/QuestionsPage';
import AuditChecklist from './Individual/Pages/Individual/Auditor/AuditChecklist';
import AuditDetails from './Individual/Pages/Individual/Auditor/AuditDetails';
import AuditSections from './Individual/Pages/Individual/Auditor/AuditSections';
import NewAuditSections from './Individual/Pages/Individual/Auditor/NewAuditSections';

import AuditOverview from './Individual/Pages/Individual/Auditor/AuditOverview';
import InAuditorDashboard from './Individual/Pages/Individual/Auditor/InAuditorDashboard';
import InAuditorUserProfile from './Individual/Pages/Individual/Auditor/InAuditorUserProfile';
import ReAuditChecklist from './Individual/Pages/Individual/Auditor/ReAuditChecklist';
import ReAuditDetails from './Individual/Pages/Individual/Auditor/ReAuditDetails';
import ReAuditSections from './Individual/Pages/Individual/Auditor/ReAuditSections';
import IndividualAuditOverview from './Individual/Pages/Individual/IndividualAuditOverview';
import IndividualAuditorCreate from './Individual/Pages/Individual/IndividualAuditorCreate';
import IndividualBranch from './Individual/Pages/Individual/IndividualBranch';
import IndividualDashboard from './Individual/Pages/Individual/IndividualDashboard';
import IndividualDepartment from './Individual/Pages/Individual/IndividualDepartment';
import IndividualDepartmentUser from './Individual/Pages/Individual/IndividualDepartmentUser';
import IndividualReAuditOverview from './Individual/Pages/Individual/IndividualReAuditOverview';
import IndividualStructure from './Individual/Pages/Individual/IndividualStructure';
import IndividualUserProfile from './Individual/Pages/Individual/IndividualUserProfile';
import VerifyAuditor from './Individual/Pages/Individual/VerifyAuditor';
import VerifyDepartmentUser from './Individual/Pages/Individual/VerifyDepartmentUser';
import AuditorLoginPage from './Individual/Pages/LoginPage/AuditorLoginPage';
import LoginPage from './Individual/Pages/LoginPage/LoginPage';




import InDuserAudit from './Individual/Pages/Individual/DepartmentUser/InDuserAudit';
import InDuserAuditDetails from './Individual/Pages/Individual/DepartmentUser/InDuserAuditDetails';
import InDuserDashboard from './Individual/Pages/Individual/DepartmentUser/InDuserDashboard';
import InDuserProfile from './Individual/Pages/Individual/DepartmentUser/InDuserProfile';
import InDuserReAudit from './Individual/Pages/Individual/DepartmentUser/InDuserReAudit';




import BusinessAuditChecklist from './Business/Pages/Business/Auditor/BusinessAuditChecklist';
import BusinessAuditDetails from './Business/Pages/Business/Auditor/BusinessAuditDetails';
import BusinessAuditSections from './Business/Pages/Business/Auditor/BusinessAuditSections';
import BusinessAuditorDashboard from './Business/Pages/Business/Auditor/BusinessAuditorDashboard';
import BusinessAuditorUserProfile from './Business/Pages/Business/Auditor/BusinessAuditorUserProfile';
import BusinessReAuditChecklist from './Business/Pages/Business/Auditor/BusinessReAuditChecklist';
import BusinessReAuditDetails from './Business/Pages/Business/Auditor/BusinessReAuditDetails';
import BusinessReAuditSections from './Business/Pages/Business/Auditor/BusinessReAuditSections';
import BusinessAuditOverview from './Business/Pages/Business/BusinessAuditOverview';
import BusinessAuditorCreate from './Business/Pages/Business/BusinessAuditorCreate';
import BusinessBranch from './Business/Pages/Business/BusinessBranch';
import BusinessDashboard from './Business/Pages/Business/BusinessDashboard';
import BusinessDepartment from './Business/Pages/Business/BusinessDepartment';
import BusinessDepartmentUser from './Business/Pages/Business/BusinessDepartmentUser';
import BusinessStructure from './Business/Pages/Business/BusinessStructure';
import BusinessUserProfile from './Business/Pages/Business/BusinessUserProfile';
import BusinessVerifyAuditor from './Business/Pages/Business/BusinessVerifyAuditor';
import BusinessVerifyDepartmentUser from './Business/Pages/Business/BusinessVerifyDepartmentUser';
import BusinessChecklistOverview from './Business/Pages/Checklist/BusinessChecklistOverview';
import BusinessCreateChecklist from './Business/Pages/Checklist/BusinessCreateChecklist';
import BusinessQuestionsPage from './Business/Pages/Checklist/BusinessQuestionsPage';

import BusinessDuserAudit from './Business/Pages/Business/DepartmentUser/BusinessDuserAudit';
import BusinessDuserAuditDetails from './Business/Pages/Business/DepartmentUser/BusinessDuserAuditDetails';
import BusinessDuserDashboard from './Business/Pages/Business/DepartmentUser/BusinessDuserDashboard';
import BusinessDuserProfile from './Business/Pages/Business/DepartmentUser/BusinessDuserProfile';
import BusinessDuserReAudit from './Business/Pages/Business/DepartmentUser/BusinessDuserReAudit';


//Factory----------

import FactoryChecklistOverview from './Factory/Pages/Checklist/FactoryChecklistOverview';
import FactoryCreateChecklist from './Factory/Pages/Checklist/FactoryCreateChecklist';
import FactoryQuestionsPage from './Factory/Pages/Checklist/FactoryQuestionsPage';
import FactoryAuditChecklist from './Factory/Pages/Factory/Auditor/FactoryAuditChecklist';
import FactoryAuditDetails from './Factory/Pages/Factory/Auditor/FactoryAuditDetails';
import FactoryAuditSections from './Factory/Pages/Factory/Auditor/FactoryAuditSections';
import FactoryAuditorDashboard from './Factory/Pages/Factory/Auditor/FactoryAuditorDashboard';
import FactoryAuditorUserProfile from './Factory/Pages/Factory/Auditor/FactoryAuditorUserProfile';
import FactoryReAuditChecklist from './Factory/Pages/Factory/Auditor/FactoryReAuditChecklist';
import FactoryReAuditDetails from './Factory/Pages/Factory/Auditor/FactoryReAuditDetails';
import FactoryReAuditSections from './Factory/Pages/Factory/Auditor/FactoryReAuditSections';
import FactoryAuditOverview from './Factory/Pages/Factory/FactoryAuditOverview';
import FactoryAuditorCreate from './Factory/Pages/Factory/FactoryAuditorCreate';
import FactoryBranch from './Factory/Pages/Factory/FactoryBranch';
import FactoryBranchAdmin from './Factory/Pages/Factory/FactoryBranchAdmin';
import FactoryDashboard from './Factory/Pages/Factory/FactoryDashboard';
import FactoryDepartment from './Factory/Pages/Factory/FactoryDepartment';
import FactoryDepartmentUser from './Factory/Pages/Factory/FactoryDepartmentUser';
import FactoryStructure from './Factory/Pages/Factory/FactoryStructure';
import FactoryUserProfile from './Factory/Pages/Factory/FactoryUserProfile';
import FactoryVerifyAuditor from './Factory/Pages/Factory/FactoryVerifyAuditor';
import FactoryVerifyDepartmentUser from './Factory/Pages/Factory/FactoryVerifyDepartmentUser';


import FactoryDuserAudit from './Factory/Pages/Factory/DepartmentUser/FactoryDuserAudit';
import FactoryDuserAuditDetails from './Factory/Pages/Factory/DepartmentUser/FactoryDuserAuditDetails';
import FactoryDuserDashboard from './Factory/Pages/Factory/DepartmentUser/FactoryDuserDashboard';
import FactoryDuserProfile from './Factory/Pages/Factory/DepartmentUser/FactoryDuserProfile';
import FactoryDuserReAudit from './Factory/Pages/Factory/DepartmentUser/FactoryDuserReAudit';
import AcceptJoinRequest from './Individual/Pages/Individual/AcceptJoinRequest';


//---------------Joined Branch------------------

import JBranchChecklistOverview from './JoinedBranch/Pages/Checklist/JBranchChecklistOverview';
import JBranchCreateChecklist from './JoinedBranch/Pages/Checklist/JBranchCreateChecklist';
import JBranchQuestionsPage from './JoinedBranch/Pages/Checklist/JBranchQuestionsPage';
import JBranchAuditChecklist from './JoinedBranch/Pages/JBranch/Auditor/JBranchAuditChecklist';
import JBranchAuditDetails from './JoinedBranch/Pages/JBranch/Auditor/JBranchAuditDetails';
import JBranchAuditSections from './JoinedBranch/Pages/JBranch/Auditor/JBranchAuditSections';
import JBranchAuditorDashboard from './JoinedBranch/Pages/JBranch/Auditor/JBranchAuditorDashboard';
import JBranchAuditorUserProfile from './JoinedBranch/Pages/JBranch/Auditor/JBranchAuditorUserProfile';
import JBranchReAuditChecklist from './JoinedBranch/Pages/JBranch/Auditor/JBranchReAuditChecklist';
import JBranchReAuditDetails from './JoinedBranch/Pages/JBranch/Auditor/JBranchReAuditDetails';
import JBranchReAuditSections from './JoinedBranch/Pages/JBranch/Auditor/JBranchReAuditSections';
import JBranchAuditOverview from './JoinedBranch/Pages/JBranch/JBranchAuditOverview';
import JBranchAuditorCreate from './JoinedBranch/Pages/JBranch/JBranchAuditorCreate';
import JBranchBranch from './JoinedBranch/Pages/JBranch/JBranchBranch';
import JBranchDashboard from './JoinedBranch/Pages/JBranch/JBranchDashboard';
import JBranchDepartment from './JoinedBranch/Pages/JBranch/JBranchDepartment';
import JBranchDepartmentUser from './JoinedBranch/Pages/JBranch/JBranchDepartmentUser';
import JBranchStructure from './JoinedBranch/Pages/JBranch/JBranchStructure';
import JBranchUserProfile from './JoinedBranch/Pages/JBranch/JBranchUserProfile';



import JBranchDuserAudit from './JoinedBranch/Pages/JBranch/DepartmentUser/JBranchDuserAudit';
import JBranchDuserAuditDetails from './JoinedBranch/Pages/JBranch/DepartmentUser/JBranchDuserAuditDetails';
import JBranchDuserDashboard from './JoinedBranch/Pages/JBranch/DepartmentUser/JBranchDuserDashboard';
import JBranchDuserProfile from './JoinedBranch/Pages/JBranch/DepartmentUser/JBranchDuserProfile';
import JBranchDuserReAudit from './JoinedBranch/Pages/JBranch/DepartmentUser/JBranchDuserReAudit';




// Create a new component for handling initial routing
const InitialRouteHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // Only run this check if we're at the root path
    if (location.pathname === '/' || location.pathname === '/HomePage') {
      const userData = JSON.parse(localStorage.getItem('user'));
      const auditorData = JSON.parse(localStorage.getItem('auditor'));
      const dUserData = JSON.parse(localStorage.getItem('dUser'));
      
      if (userData) {
        // User is logged in - redirect based on role and account type
        if (userData.accountType === 'individual' && userData.role === 'Branch admin') {
          navigate('/IndividualDashboard');
        } else if (userData.accountType === 'business' && userData.role === 'Company admin') {
          navigate('/BusinessDashboard');
        }
      } else if (auditorData) {
        // Auditor is logged in - redirect based on role and account type
        if (auditorData.accountType === 'individual' && auditorData.role === 'Branch auditor') {
          navigate('/InAuditorDashboard');
        } else if (auditorData.accountType === 'business' && auditorData.role === 'Company auditor') {
          navigate('/BusinessAuditorDashboard');
        }
      }
      else if (dUserData) {
        // Auditor is logged in - redirect based on role and account type
        if (dUserData.accountType === 'individual' && dUserData.role === 'Department user') {
          navigate('/InDuserDashboard');
        } else if (dUserData.accountType === 'business' && dUserData.role === 'Department user') {
          navigate('/BusinessDuserDashboard');
        }
      }
    }
  }, [location.pathname, navigate]);
  
  // This component doesn't render anything itself
  return null;
};

// Modify your AppContent component
const AppContent = () => {
  const location = useLocation();
  
  // List of routes where navbar should be hidden
  const hideNavbarRoutes = [
    '/VerifyDepartmentUser',
    '/VerifyAuditor',
    '/BusinessVerifyDepartmentUser',
    '/BusinessVerifyAuditor',
    '/FactoryVerifyDepartmentUser',
    '/FactoryVerifyAuditor',
    '/AcceptJoinRequest'
    // Add other routes where navbar should be hidden
  ];
  
  // Check if current path should hide navbar
  const shouldHideNavbar = hideNavbarRoutes.some(route => 
    location.pathname === route || location.pathname.startsWith(`${route}/`)
  );
  
  return (
    <>
      <AutoLogout />
      <InitialRouteHandler /> {/* Add this component to handle initial routing */}
      {!shouldHideNavbar && <Navbar />}
      <AuthWrapper>
        <Routes>
          {/* Home routes */}
          <Route path="/HomePage" element={<HomePage />} />
          <Route path="/overview" element={<Overview />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/" element={<HomePage />} />

          <Route path="/LoginTabs" element={<LoginTabs />} />
          <Route path="/RegisterTabs" element={<RegisterTabs />} />
          <Route path="/LoginPage" element={<LoginPage />} />
          <Route path="/auditor-login" element={<AuditorLoginPage />} />
          <Route path="/forgot-password/admin" element={<ForgotPassword />} />
          <Route path="/forgot-password/auditor" element={<AuditorForgotPassword />} />
          <Route path="/forgot-password/dUser" element={<DuserForgotPassword />} />

          <Route path="/IndividualRegister" element={<IndividualRegister />} />
          <Route path="/BusinessRegister" element={<BusinessRegister />} />
          <Route path="/VerifyDepartmentUser" element={<VerifyDepartmentUser />} />
          <Route path="/VerifyAuditor" element={<VerifyAuditor />} />
          <Route path="/BusinessVerifyDepartmentUser" element={<BusinessVerifyDepartmentUser />} />
          <Route path="/BusinessVerifyAuditor" element={<BusinessVerifyAuditor />} />
          <Route path="/FactoryVerifyDepartmentUser" element={<FactoryVerifyDepartmentUser />} />
          <Route path="/FactoryVerifyAuditor" element={<FactoryVerifyAuditor />} />
          <Route path="/AcceptJoinRequest" element={<AcceptJoinRequest />} />




            {/* Individual Routes */}
            <Route element={<AdminPrivateRoute allowedRoles={["Branch admin"]} allowedTypes={["individual"]} />}>
                <Route path="/IndividualDashboard" element={<IndividualDashboard />} />
                <Route path="/IndividualBranch" element={<IndividualBranch />} />
                <Route path="/IndividualDepartment" element={<IndividualDepartment />} />
                <Route path="/IndividualStructure" element={<IndividualStructure />} />
                <Route path="/IndividualAuditorCreate" element={<IndividualAuditorCreate />} />
                <Route path="/CreateChecklist" element={<CreateChecklist />} />
                <Route path="/ChecklistOverview" element={<ChecklistOverview />} />
                <Route path="/QuestionsPage" element={<QuestionsPage />} />
                <Route path="/EditChecklist/:id" element={<CreateChecklist isEditing={true} />} />
                <Route path="/IndividualUserProfile/:id" element={<IndividualUserProfile />} />
                <Route path="/IndividualDepartmentUser" element={<IndividualDepartmentUser />} />
                <Route path="/IndividualAuditOverview" element={<IndividualAuditOverview />} />
                <Route path="/IndividualReAuditOverview" element={<IndividualReAuditOverview />} />
            </Route>
          
          
          {/* Auditor Routes */}


          <Route element={<AuditorPrivateRoute allowedRoles={["Branch auditor"]} allowedTypes={["individual"]} />}>
              <Route path="/InAuditorDashboard" element={<InAuditorDashboard />} />
              <Route path="/InAuditorUserProfile/:id" element={<InAuditorUserProfile />} />
              <Route path="/AuditChecklist" element={<AuditChecklist />} />
              <Route path="/AuditDetails" element={<AuditDetails />} />
              <Route path="/AuditSections" element={<AuditSections />} />
              <Route path="/NewAuditSections" element={<NewAuditSections />} />
              <Route path="/ReAuditDetails" element={<ReAuditDetails />} />
              <Route path="/ReAuditSections" element={<ReAuditSections />} />
              <Route path="/ReAuditChecklist" element={<ReAuditChecklist />} /> 
              <Route path="/AuditOverview" element={<AuditOverview />} /> 

                      
            </Route>

             {/* Individual Routes */}
             <Route element={<DuserPrivateRoute allowedRoles={["Department user"]} allowedTypes={["individual"]} />}>
                <Route path="/InDuserDashboard" element={<InDuserDashboard />} />
                <Route path="/InDuserAudit" element={<InDuserAudit />} />
                <Route path="/InDuserProfile/:id" element={<InDuserProfile />} />
                <Route path="/InDuserAuditDetails" element={<InDuserAuditDetails />} />
                <Route path="/InDuserReAudit" element={<InDuserReAudit />} />                
            </Route>


          {/* Business Routes */}
          
          <Route element={<AdminPrivateRoute allowedRoles={["Company admin"]} allowedTypes={["business"]} />}>
                <Route path="/BusinessDashboard" element={<BusinessDashboard />} />
                <Route path="/BusinessBranch" element={<BusinessBranch />} />
                <Route path="/BusinessDepartment" element={<BusinessDepartment />} />
                <Route path="/BusinessStructure" element={<BusinessStructure />} />
                <Route path="/BusinessAuditorCreate" element={<BusinessAuditorCreate />} />
                <Route path="/BusinessCreateChecklist" element={<BusinessCreateChecklist />} />
                <Route path="/BusinessChecklistOverview" element={<BusinessChecklistOverview />} />
                <Route path="/BusinessQuestionsPage" element={<BusinessQuestionsPage />} />
                <Route path="/BusinessEditChecklist/:id" element={<BusinessCreateChecklist isEditing={true} />} />
                <Route path="/BusinessUserProfile/:id" element={<BusinessUserProfile />} />
                <Route path="/BusinessDepartmentUser" element={<BusinessDepartmentUser />} />
                <Route path="/BusinessAuditOverview" element={<BusinessAuditOverview />} />

            </Route>
          
          
          {/* Auditor Routes */}


          <Route element={<AuditorPrivateRoute allowedRoles={["Company auditor"]} allowedTypes={["business"]} />}>
              <Route path="/BusinessAuditorDashboard" element={<BusinessAuditorDashboard />} />
              <Route path="/BusinessAuditorUserProfile/:id" element={<BusinessAuditorUserProfile />} />
              <Route path="/BusinessAuditChecklist" element={<BusinessAuditChecklist />} />
              <Route path="/BusinessAuditDetails" element={<BusinessAuditDetails />} />
              <Route path="/BusinessAuditSections" element={<BusinessAuditSections />} />
              <Route path="/BusinessReAuditDetails" element={<BusinessReAuditDetails />} />
              <Route path="/BusinessReAuditSections" element={<BusinessReAuditSections />} />
              <Route path="/BusinessReAuditChecklist" element={<BusinessReAuditChecklist />} />         
             
            </Route>

            <Route element={<DuserPrivateRoute allowedRoles={["Department user"]} allowedTypes={["business"]} />}>
                <Route path="/BusinessDuserDashboard" element={<BusinessDuserDashboard />} />
                <Route path="/BusinessDuserAudit" element={<BusinessDuserAudit />} />
                <Route path="/BusinessDuserProfile/:id" element={<BusinessDuserProfile />} />
                <Route path="/BusinessDuserAuditDetails" element={<BusinessDuserAuditDetails />} />
                <Route path="/BusinessDuserReAudit" element={<BusinessDuserReAudit />} />                
            </Route>


            <Route element={<AdminPrivateRoute allowedRoles={["Factory admin"]} allowedTypes={["factory"]} />}>
                <Route path="/FactoryDashboard" element={<FactoryDashboard />} />
                <Route path="/FactoryBranch" element={<FactoryBranch />} />
                <Route path="/FactoryDepartment" element={<FactoryDepartment />} />
                <Route path="/FactoryStructure" element={<FactoryStructure />} />
                <Route path="/FactoryAuditorCreate" element={<FactoryAuditorCreate />} />
                <Route path="/FactoryCreateChecklist" element={<FactoryCreateChecklist />} />
                <Route path="/FactoryChecklistOverview" element={<FactoryChecklistOverview />} />
                <Route path="/FactoryQuestionsPage" element={<FactoryQuestionsPage />} />
                <Route path="/FactoryEditChecklist/:id" element={<FactoryCreateChecklist isEditing={true} />} />
                <Route path="/FactoryUserProfile/:id" element={<FactoryUserProfile />} />
                <Route path="/FactoryDepartmentUser" element={<FactoryDepartmentUser />} />
                <Route path="/FactoryAuditOverview" element={<FactoryAuditOverview />} />
                
                <Route path="/FactoryBranchAdmin" element={<FactoryBranchAdmin />} />

            </Route>
          
          
          {/* Auditor Routes */}


          <Route element={<AuditorPrivateRoute allowedRoles={["Factory auditor"]} allowedTypes={["factory"]} />}>
              <Route path="/FactoryAuditorDashboard" element={<FactoryAuditorDashboard />} />
              <Route path="/FactoryAuditorUserProfile/:id" element={<FactoryAuditorUserProfile />} />
              <Route path="/FactoryAuditChecklist" element={<FactoryAuditChecklist />} />
              <Route path="/FactoryAuditDetails" element={<FactoryAuditDetails />} />
              <Route path="/FactoryAuditSections" element={<FactoryAuditSections />} />
              <Route path="/FactoryReAuditDetails" element={<FactoryReAuditDetails />} />
              <Route path="/FactoryReAuditSections" element={<FactoryReAuditSections />} />
              <Route path="/FactoryReAuditChecklist" element={<FactoryReAuditChecklist />} />         
             
            </Route>

            <Route element={<DuserPrivateRoute allowedRoles={["Department user"]} allowedTypes={["factory"]} />}>
                <Route path="/FactoryDuserDashboard" element={<FactoryDuserDashboard />} />
                <Route path="/FactoryDuserAudit" element={<FactoryDuserAudit />} />
                <Route path="/FactoryDuserProfile/:id" element={<FactoryDuserProfile />} />
                <Route path="/FactoryDuserAuditDetails" element={<FactoryDuserAuditDetails />} />
                <Route path="/FactoryDuserReAudit" element={<FactoryDuserReAudit />} />                
            </Route>




             {/* Joined Branch Routes */}
             <Route element={<AdminPrivateRoute allowedRoles={["Branch admin"]} allowedTypes={["Joined Branch"]} />}>
             <Route path="/JBranchDashboard" element={<JBranchDashboard />} />
             <Route path="/JBranchBranch" element={<JBranchBranch />} />
             <Route path="/JBranchDepartment" element={<JBranchDepartment />} />
             <Route path="/JBranchStructure" element={<JBranchStructure />} />
             <Route path="/JBranchAuditorCreate" element={<JBranchAuditorCreate />} />
             <Route path="/JBranchCreateChecklist" element={<JBranchCreateChecklist />} />
             <Route path="/JBranchChecklistOverview" element={<JBranchChecklistOverview />} />
             <Route path="/JBranchQuestionsPage" element={<JBranchQuestionsPage />} />
             <Route path="/JBranchEditChecklist/:id" element={<JBranchCreateChecklist isEditing={true} />} />
             <Route path="/JBranchUserProfile/:id" element={<JBranchUserProfile />} />
             <Route path="/JBranchDepartmentUser" element={<JBranchDepartmentUser />} />
             <Route path="/JBranchAuditOverview" element={<JBranchAuditOverview />} />
            </Route>
            
            
            {/* Joined Branch Auditor Routes */}
            
            
            <Route element={<AuditorPrivateRoute allowedRoles={["Branch auditor"]} allowedTypes={["Joined Branch"]} />}>
            <Route path="/JBranchAuditorDashboard" element={<JBranchAuditorDashboard />} />
            <Route path="/JBranchAuditorUserProfile/:id" element={<JBranchAuditorUserProfile />} />
            <Route path="/JBranchAuditChecklist" element={<JBranchAuditChecklist />} />
            <Route path="/JBranchAuditDetails" element={<JBranchAuditDetails />} />
            <Route path="/JBranchAuditSections" element={<JBranchAuditSections />} />
            <Route path="/JBranchReAuditDetails" element={<JBranchReAuditDetails />} />
            <Route path="/JBranchReAuditSections" element={<JBranchReAuditSections />} />
            <Route path="/JBranchReAuditChecklist" element={<JBranchReAuditChecklist />} />         
            </Route>
            
            {/* Joined Branch d user Routes */}
            <Route element={<DuserPrivateRoute allowedRoles={["Department user"]} allowedTypes={["Joined Branch"]} />}>
             <Route path="/JBranchDuserDashboard" element={<JBranchDuserDashboard />} />
             <Route path="/JBranchDuserAudit" element={<JBranchDuserAudit />} />
             <Route path="/JBranchDuserProfile/:id" element={<JBranchDuserProfile />} />
             <Route path="/JBranchDuserAuditDetails" element={<JBranchDuserAuditDetails />} />
             <Route path="/JBranchDuserReAudit" element={<JBranchDuserReAudit />} />                
            </Route>
            


          
        </Routes>
      </AuthWrapper>

    </>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
